import { render, staticRenderFns } from "./ListArticleItem.vue?vue&type=template&id=452cb940&scoped=true"
import script from "./ListArticleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleItem.vue?vue&type=style&index=0&id=452cb940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452cb940",
  null
  
)

export default component.exports